import {useQuery} from '@tanstack/react-query';

import {fetchWorkstreamAutodraft} from './workstreamAutodraftApi';

const autodraftQueryKey = (workstreamId: number) =>
  ['workstream', 'autodraft', workstreamId] as const;

export const useWorkstreamAutodraft = (workstreamId: number, enabled = true) =>
  useQuery({
    queryKey: autodraftQueryKey(workstreamId),
    queryFn: () => fetchWorkstreamAutodraft(workstreamId),
    enabled: enabled && workstreamId > 0,
    staleTime: 30_000,
  });
